import {useEffect} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {useStore} from 'zustand';
import {useEventBus} from '../../../../../hooks/useEventBus';
import {LoadableHelpers} from '../../../../../shared/helpers/loadableHelpers';
import {dashboardPrimaryChartQuery} from '../../../../../store/reports/selectors';
import {PERIOD_VALUES} from '../constants/period';
import {usePrimaryChartsDataStore} from '../store/usePrimaryChartsDataStore';
import {useStoresContext} from './useStoresContext';

export const usePrimaryChartDataGate = (serviceType: string) => {
  const {primaryChartsFiltersStore: pS, dashboardArchiveFilterStore} = useStoresContext(serviceType);
  const bus = useEventBus();
  const period = useStore(pS, (s) => PERIOD_VALUES[s.period]);
  const from = useStore(pS, (s) => s.customPeriodStart);
  const to = useStore(pS, (s) => s.customPeriodEnd);
  const archived = useStore(dashboardArchiveFilterStore, (s) => s.archived);
  const data = useRecoilValueLoadable(
    dashboardPrimaryChartQuery({period, from, to, serviceType, isArchive: archived ? true : undefined}),
  );

  const {setContracts, setIsLoading} = usePrimaryChartsDataStore();

  useEffect(() => {
    LoadableHelpers.handle(data, {
      success: (content) => setContracts(content),
      loading: () => setIsLoading(true),
      error: (key, payload) => {
        setIsLoading(false);
        bus?.emit(key, payload);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bus, data, setContracts, setIsLoading]);
};
